// Root Reducers - Modular Organization
// This file aggregates all module-level reducers

// Admin Modules
import profileReducers from 'modules/Admin/Profile/reducers'
import accountsReducers from 'modules/Admin/Accounts/reducers'
import companiesReducers from 'modules/Admin/Companies/reducers'
import employeesReducers from 'modules/Admin/Employees/reducers'
import inventoryReducers from 'modules/Admin/Inventory/reducers'
import reportsReducers from 'modules/Admin/Reports/reducers'

// Public Modules
import publicReducers from 'modules/Public/reducers'
import { Auth } from 'modules/Public/SignIn/store/slice'

// -------

const reducers = {
  // Admin Modules
  ...profileReducers,
  ...accountsReducers,
  ...companiesReducers,
  ...employeesReducers,
  ...inventoryReducers,
  ...reportsReducers,

  // Public Modules
  ...publicReducers,
};

console.log('ROOT:Reducers', reducers);

export const AuthReducer = Auth
export default reducers;
